import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import {
  MarketAnnouncement,
  SimpleMarketAnnouncement,
} from '../../../models/mysec/market-announcement.model';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AnnouncementModel } from '../../../models/campaign/announcements.model';

@Injectable({
  providedIn: 'root',
})
export class MarketAnnouncementService {
  private route = environment.apiServer + 'api/v1/MySec/marketAnnouncement';
  private routeCreateAnnouncement = environment.apiServer + 'Api/v1/MySec/{role}';

  constructor(private http: HttpClient) {}

  getAnnouncementBar(): Observable<SimpleMarketAnnouncement[]> {
    const params = { noToken: 'noToken' };
    return this.http.get(this.route + '/announcementBar', { params }).pipe(
      map((data: any) => {
        return data.result;
      }),
    );
  }

  getAnnouncementDetails(slug: string): Observable<MarketAnnouncement> {
    const params = { noToken: 'noToken' };
    return this.http.get(this.route + '/' + slug, { params }).pipe(
      map((data: any) => {
        return data.result;
      }),
    );
  }
  createMarketAnnouncement(companyId: number, announcement: AnnouncementModel): Observable<AnnouncementModel> {
    return this.http
      .post(
        this.routeCreateAnnouncement + '/markets/company/' + companyId + '/Companies/announcement',
        announcement,
      )
      .pipe(map((data: any) => data.result));
  }

  deleteMarketAnnouncement(companyId: number, announcementId: number): Observable<boolean> {
    return this.http
      .delete(
        this.routeCreateAnnouncement + '/markets/company/' + companyId + '/Companies/announcement/' + announcementId,
      )
      .pipe(map((data: any) => data.result));
  }

}
